module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/bg_fukidashi-83d9dbf20f20f21392b6b81b3827f284.svg";